import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Prescription } from '../../models/electronic-prescription/prescription';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PrescriptionSelectDrug } from '../../models/electronic-prescription/prescription-select-drug';
import * as _ from 'lodash-es';
import { FormControl, FormGroup } from '@angular/forms';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { debounceTime } from 'rxjs/operators';
import { LoggingGroupModel } from 'src/app/models/logging-model';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { PrescriptionDrugMessages } from '../../models/electronic-prescription/prescription-drug-messages';
import {
  ReferralPaperDoctorRequest,
  ReferralRequest,
} from '../../models/electronic-prescription/referral-request';
import { SaleFactorType } from 'src/app/enum/sale-factor-type';
import { PrescriptionPageDatabase } from '../../models/electronic-prescription/prescription-page-database';
import { GetActivePrescriptionViewModel } from '../../models/electronic-prescription/get-active-prescription-view-model';
import { TaminService } from '../../services/tamin.service';
import { NewCalendarService } from 'src/app/services/new-calender-service';
import { SearchBoxComponent } from '../../components/search-box/search-box.component';
import { ModalConfirm } from '../../models/modal-confirm';
import { ReturnModalComponent } from '../../components/return-modal/return-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { SalamatService } from '../../services/salamat.service';
import { UIdModel } from '../../models/uid-model';
import {
  checkCodeViewModel,
  checkOtherServices,
  uidViewModel,
} from '../../models/SalamatModel/salamat-prescription';
import { Recept, ReceptDrugList } from '../../models/recept';
import { Guid } from 'src/app/services/guid';
import { ExpertiseGradeEnum } from 'src/app/enum/expertise-grade-enum';
import { Referral } from '../../models/digital-prescriotion-salamat/referral';
import { PrescriptionDrug } from '../../models/digital-prescriotion-salamat/prescription-drug';
import { PrescriptionDrugStock } from '../../models/digital-prescriotion-salamat/prescription-drug-stock';
import { PrescriptionDrugValidation } from '../../models/digital-prescriotion-salamat/prescription-drug-validation';

@Component({
  selector: 'app-digital-prescription-salamat',
  templateUrl: './digital-prescription-salamat.component.html',
  styleUrl: './digital-prescription-salamat.component.css',
})
export class DigitalPrescriptionSalamatComponent implements OnInit {
  public boxList: boolean[] = [true, true, true, true];
  public searchFields: any[] = [];
  public searchStockFields: any[] = [];
  public boxIdList: string[] = [
    'input-prescription-information',
    'prescription-information',
    'prescription-details',
    'select-prescription-details',
  ];

  public salamatData: any[] = [
    {
      persianName: 'هر 2 ساعت',
      id: 'Every two hours',
    },
    {
      persianName: 'هر 3 ساعت',
      id: 'Every three hours',
    },
    {
      persianName: 'هر 4 ساعت',
      id: 'Every four hours',
    },
    {
      persianName: 'هر 6 ساعت',
      id: 'Every six hours',
    },
    {
      persianName: 'هر 8 ساعت',
      id: 'Every eight hours',
    },
    {
      persianName: 'هر 12 ساعت',
      id: 'Every twelve hours',
    },
    {
      persianName: 'هر 36 ساعت',
      id: 'Every thirty six hours',
    },
    {
      persianName: 'روزی یک عدد',
      id: 'Once a day',
    },
    {
      persianName: 'روزانه یک عدد',
      id: 'Once daily',
    },
    {
      persianName: 'هر روز',
      id: 'Every day',
    },
    {
      persianName: 'یک روز در میان',
      id: 'Every other day',
    },
    {
      persianName: 'یک شب در میان',
      id: 'Every other night',
    },
    {
      persianName: '2 بار در روز',
      id: 'Twice a day',
    },
    {
      persianName: '2 بار روزانه',
      id: 'Twice daily',
    },
    {
      persianName: '3 بار در روز',
      id: 'Three times a day',
    },
    {
      persianName: '4 بار در روز',
      id: 'Four times a day',
    },
    {
      persianName: 'هر 10 روز',
      id: 'Every ten days',
    },
    {
      persianName: 'هر 28 روز',
      id: 'Every twenty eight days',
    },
    {
      persianName: 'هر ساعت',
      id: 'Every hour',
    },
    {
      persianName: 'هر هفته',
      id: 'Every week',
    },
    {
      persianName: 'هر ماه',
      id: 'Every month',
    },
    {
      persianName: 'هر سال',
      id: 'Every year',
    },
    {
      persianName: 'هر صبح',
      id: 'Every morning',
    },
    {
      persianName: 'هر شب',
      id: 'Every night',
    },
    {
      persianName: 'هر دو هفته',
      id: 'Every other week',
    },
    {
      persianName: 'هر سه هفته',
      id: 'Every three weeks',
    },
    {
      persianName: 'دو روز در هفته',
      id: 'Twice a week',
    },
    {
      persianName: 'هر سه ماه',
      id: 'Every three months',
    },
    {
      persianName: 'هر شش ماه',
      id: 'Every six months',
    },
    {
      persianName: 'پنج روز در هفته',
      id: 'Five days a week',
    },
    {
      persianName: 'طبق دستور',
      id: 'As directed',
    },
    {
      persianName: 'در مواقع لازم',
      id: 'As needed',
    },
    {
      id: 'Hourly',
      persianName: 'هر ساعت',
    },
  ];

  public salamatNumberOfPeriod: any[] = [
    { id: '1', persianName: '1' },
    { id: '2', persianName: '2' },
    { id: '3', persianName: '3' },
    { id: '4', persianName: '4' },
    { id: '0.5', persianName: '1/2(یکدوم)' },
    { id: '0.25', persianName: '1/4(یکچهارم)' },
    { id: '0.75', persianName: '3/4(سهچهارم)' },
    { id: '1.25', persianName: '1.25(یکویکچهارم)' },
    { id: '1.5', persianName: '1.5(یکویکدوم)' },
    { id: '1.75', persianName: '1.75(یکوسهچهارم)' },
    { id: '5', persianName: '5' },
    { id: '6', persianName: '6' },
    { id: '7', persianName: '7' },
    { id: '8', persianName: '8' },
    { id: '9', persianName: '9' },
    { id: '10', persianName: '10' },
    { id: '11', persianName: '11' },
    { id: '12', persianName: '12' },
    { id: '13', persianName: '13' },
    { id: '14', persianName: '14' },
  ];

  public technicalRight: string = '';

  public referral: Referral = new Referral();
  public referralRequest: ReferralRequest;
  public loading: boolean = false;
  public listLoading: boolean = false;
  public drugSearchForm: FormGroup;
  public modalIsOpen: boolean = false;
  public bulkModalIsOpen: boolean = false;
  public receptModalIsOpen: boolean = false;
  public searchData?: PCTableInputModel;
  public searchSalamatData?: PCTableInputModel;
  public searchPaging?: TabelPaging;
  public searchRequestModel: PCSearchRequestModel;
  public selectedIndex: number = -1;
  public searchItem: string = '';
  public editItem?: PrescriptionDrug = undefined;
  public editItemValidation: PrescriptionDrugValidation =
    new PrescriptionDrugValidation();
  public activeSearch: boolean = false;
  public activeBulkSearch: boolean = false;
  public modalSuccessConfirm: boolean = false;
  public messageModalActive?: PrescriptionDrugMessages;
  public recept: Recept | undefined;
  public editableLoading: boolean = false;
  public showEditable: boolean = false;
  public editableListItem: any[] = [];

  public modalConfirm: boolean = false;
  public showAddBox: boolean = false;
  public confirmModal: ModalConfirm = new ModalConfirm();

  public uploadBarcodeItem?: PrescriptionSelectDrug;
  public barcodeDrugIndex?: number;

  public pageDatabase: PrescriptionPageDatabase;
  public temporarySubmittingCode?: string;
  public getBackendRequest: GetActivePrescriptionViewModel;
  public checkCodes: checkCodeViewModel[] = [];

  public isElectronic: boolean = true;
  public searchWithIRC: boolean = true;
  public referralPaperDoctorRequest: ReferralPaperDoctorRequest =
    new ReferralPaperDoctorRequest();
  public monthName: string = '';
  public expertiseGradeEnum = Object.keys(ExpertiseGradeEnum)
    .filter((key) => !isNaN(Number(ExpertiseGradeEnum[key])))
    .map((key) => ({ value: key, name: key.replaceAll(' ', '') }));
  public doctorSearchResult: any[] = [];

  public uidViewModel: uidViewModel | undefined;
  public loginState: number = -2;
  public loginModel: any = {
    userName: undefined,
    password: undefined,
    cpartySessionId: undefined,
    OTP: undefined,
  };

  public bulkItemList: any[] = [];

  public bulkParentPaper: PrescriptionDrug = new PrescriptionDrug();
  public newBulkParentPaper: PrescriptionDrug = new PrescriptionDrug();

  @ViewChild('itemEdit') itemEditModal!: NgbPopover;
  @ViewChild('ScanBarcodeModal') ScanBarcodeModal!: NgbPopover;
  @ViewChild('bulkItem') bulkItem!: NgbPopover;
  @ViewChild(SearchBoxComponent)
  searchBoxComponent!: SearchBoxComponent;
  @ViewChild('datePicker') public popoverDataPicker!: NgbPopover;

  constructor(
    private apiService: UserApiService,
    private logger: LoggerService,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private taminService: TaminService,
    private salamtService: SalamatService,
    public calenderService: NewCalendarService,
    private translate: TranslateService,
    private guid: Guid,
    private responseService: CustomizeResponseService
  ) {
    this.getSearchEntity();
    this.GetTechnicalRight();
    this.getSearchStockEntity();
    this.pageDatabase = new PrescriptionPageDatabase();
    this.getBackendRequest = new GetActivePrescriptionViewModel(0);

    this.referralRequest = new ReferralRequest();
    this.referralRequest.patientNationalCode = '4172504302';
    this.referralRequest.trackingCode = '36955';

    this.searchRequestModel = new PCSearchRequestModel();
    this.drugSearchForm = new FormGroup({
      drugBrandName: new FormControl(''),
    });

    this.renderer.listen('window', 'keyup', (e: any) => {
      if (e.key == 'F2' || e.key == 'PrintScreen') {
      }
    });
  }

  get totalPaidPrice(): number {
    const selectedDrugs = this.referral?.prescription?.selectDrug || [];
    return selectedDrugs.reduce(
      (sum, current) => sum + (current.paidPrice || 0),
      0
    );
  }

  get totalPrefExchangePart(): number {
    const selectedDrugs = this.referral?.prescription?.selectDrug || [];
    return selectedDrugs.reduce(
      (sum, current) => sum + (current.prefExchangePart || 0),
      0
    );
  }

  get totalOrgAmount(): number {
    const selectedDrugs = this.referral?.prescription?.selectDrug || [];
    return selectedDrugs.reduce(
      (sum, current) => sum + (current.orgAmount || 0),
      0
    );
  }

  get totalTotalPrice(): number {
    const selectedDrugs = this.referral?.prescription?.selectDrug || [];
    return selectedDrugs.reduce(
      (sum, current) => sum + (current.totalPrice || 0),
      0
    );
  }

  get paidPrice(): number {
    return (
      this.totalTotalPrice -
      this.totalOrgAmount -
      this.totalPrefExchangePart +
      +this.technicalRight
    );
  }

  public GetTechnicalRight() {
    try {
      let url = `TechnicalRight/Now`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            this.technicalRight = result.data.free.amount;
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
    }
  }

  public loginFirstStep() {
    try {
      this.loading = true;

      if (
        this.loginModel.userName == null ||
        this.loginModel.userName == '' ||
        this.loginModel.password == '' ||
        this.loginModel.password == null
      ) {
        return;
      }
      let url = `SaleElectronicPrescription/SalamtLogin`;

      this.apiService
        .postItem(new ApiRequestModel(url, this.loginModel))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.loginModel.cpartySessionId = result.data.info.sessionId;
              if (result.data.info.isTwoStep) {
                this.loginState++;
              } else {
                this.loginState = 0;
              }
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public loginSecondStep() {
    try {
      this.loading = true;

      if (
        this.loginModel.OTP == null ||
        this.loginModel.OTP == '' ||
        this.loginModel.cpartySessionId == null ||
        this.loginModel.cpartySessionId == ''
      ) {
        return;
      }
      let url = `SaleElectronicPrescription/CheckOTP`;

      this.apiService
        .postItem(new ApiRequestModel(url, this.loginModel))
        .subscribe(
          (result) => {
            if (result.succeeded) {
              this.loginState++;
            }
            this.loading = false;
          },
          (error) => {
            this.apiService.AddErrorLog(error);
            this.loading = false;
          },
          () => {
            this.loading = false;
          }
        );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  public skipSecondStep() {
    this.loginState++;
  }

  public ngOnInit(): void {}

  public getSearchEntity() {
    this.searchFields = [
      {
        fieldName: 'brandName',
        fieldType: 'String',
        label: 'BrandName',
        defaultValue: null,
        placeHolder: 'BrandName',
        validationPattern: null,
        propertyKey: null,
        isMandatory: false,
        isVisibleInTable: true,
        isActiveSearch: true,
        isPassword: false,
        isEditable: true,
        isCreateAble: true,
        isRelational: false,
        order: 1,
        camelCaseName: 'brandName',
      },
      {
        fieldName: 'shortName',
        fieldType: 'String',
        label: 'ShortName',
        defaultValue: null,
        placeHolder: 'ShortName',
        validationPattern: null,
        propertyKey: null,
        isMandatory: false,
        isVisibleInTable: true,
        isActiveSearch: true,
        isPassword: false,
        isEditable: true,
        isCreateAble: true,
        isRelational: false,
        order: 2,
        camelCaseName: 'shortName',
      },
      {
        fieldName: 'nationalNumber',
        fieldType: 'String',
        label: 'NationalNumber',
        defaultValue: null,
        placeHolder: 'NationalNumber',
        validationPattern: null,
        propertyKey: null,
        isMandatory: false,
        isVisibleInTable: true,
        isActiveSearch: true,
        isPassword: false,
        isEditable: true,
        isCreateAble: true,
        isRelational: false,
        order: 2,
        camelCaseName: 'nationalNumber',
      },
      {
        fieldName: 'genericCode',
        fieldType: 'String',
        label: 'GenericCode',
        defaultValue: null,
        placeHolder: 'GenericCode',
        validationPattern: null,
        propertyKey: null,
        isMandatory: false,
        isVisibleInTable: true,
        isActiveSearch: true,
        isPassword: false,
        isEditable: true,
        isCreateAble: true,
        isRelational: false,
        order: 2,
        camelCaseName: 'genericCode',
      },
    ];
  }

  private openBox(index: number) {
    const elementItem = document.getElementById(this.boxIdList[index]);
    if (elementItem == null) {
      return;
    }

    elementItem.classList.remove('hide');

    setTimeout(() => {
      this.boxList[index] = true;
    }, 1000);
  }

  private closeBox(index: number) {
    this.boxList[index] = false;

    setTimeout(() => {
      const elementItem = document.getElementById(this.boxIdList[index]);
      if (elementItem == null) {
        return;
      }

      elementItem.classList.add('hide');
    }, 500);
  }

  public openCloseBox(index: number) {
    if (this.boxList[index]) {
      this.closeBox(index);
    } else {
      this.openBox(index);
    }
  }

  public getMockData() {
    try {
      const mockUrl = `BuyFactor/MockData`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(mockUrl))) {
        return;
      }

      this.loading = true;

      this.apiService.getSingleItem(new ApiRequestModel(mockUrl)).subscribe(
        (result) => {
          this.logger.addResponseLog(mockUrl, result, 'postItem');
          if (result.succeeded) {
            this.mapDataToReferral(result.data);
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {}
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public mapDataToReferral(result: any) {
    this.referral = result;
    if (this.referral == null) {
      this.logger.addError('referral is null', false);
      return;
    }
    this.referral.prescription = result.prescriptions.map((current) => ({
      prescriptionId: current.prescriptionId,
      drugs: current.drugs.map((secondCurrent) => ({
        id: secondCurrent.id,
        organizationId: secondCurrent.organizationId,
        genericName: secondCurrent.genericCodeString,
        genericCode: secondCurrent.genericCode,
        brandName: secondCurrent.brandName,
        erxCode: secondCurrent.erxCode,
        consumption: secondCurrent.consumption,
        requestCount: secondCurrent.requestCount,
        maxCoveredCount: secondCurrent.maxCoveredCount,
        shouldSendToEsalat: secondCurrent.shouldSendToEsalat,
        checkDeliverCode:
          secondCurrent.checkDeliverCode == null
            ? undefined
            : secondCurrent.checkDeliverCode,
        organizationSharePrice:
          result.saleFactorType == 4
            ? secondCurrent.orgAmount
            : secondCurrent.organizationSharePrice,
        messages: secondCurrent.messages,
        stock: {
          stockItemId: secondCurrent.stock.stockItemId,
          stockId: secondCurrent.stock.stockId,
          drugId: secondCurrent.stock.drugId,
          brandName: secondCurrent.stock.brandName,
          expireDate: secondCurrent.stock.expireDate,
          drugPackage: secondCurrent.stock.drugPackage,
          stockName: secondCurrent.stock.stockName,
          inventoryCount: secondCurrent.stock.inventoryCount,
          saleCount: secondCurrent.stock.saleCount,
          price: secondCurrent.stock.price,
          patientSharePrice:
            secondCurrent.stock.price -
            (result.saleFactorType == 4
              ? secondCurrent.orgAmount
              : secondCurrent.organizationSharePrice),
        },
        activeSearch: false,
        isSelected: false,
      })),
      originalDrugs: _.cloneDeep(
        current.drugs.map((secondCurrent) => ({
          id: secondCurrent.id,
          organizationId: secondCurrent.organizationId,
          genericName: secondCurrent.genericName,
          genericCode: secondCurrent.genericCode,
          brandName: secondCurrent.brandName,
          erxCode: secondCurrent.erxCode,
          consumption: secondCurrent.consumption,
          requestCount: secondCurrent.requestCount,
          maxCoveredCount: secondCurrent.maxCoveredCount,
          shouldSendToEsalat: secondCurrent.shouldSendToEsalat,
          organizationSharePrice: secondCurrent.organizationSharePrice,
          messages: secondCurrent.messages,
          stock: secondCurrent.stock,
          activeSearch: false,
          isSelected: false,
        }))
      ),
    }));
  }

  public clearPage() {
    this.referral = new Referral();
    this.closeAllCollapse();
  }

  public validatePrescription(): boolean {
    let result = true;
    if (this.referralRequest.patientNationalCode == null) {
      this.referralRequest.patientNationalCodeMessage = 'Required';
      result = false;
    } else if (!/^\d+$/.test(this.referralRequest.patientNationalCode)) {
      this.referralRequest.patientNationalCodeMessage = 'invalid_Pattern';
      result = false;
    } else if (this.referralRequest.patientNationalCode.length != 10) {
      this.referralRequest.patientNationalCodeMessage = 'invalid_Length';
      result = false;
    } else {
      this.referralRequest.patientNationalCodeMessage = undefined;
    }

    if (this.referralRequest.trackingCode == null) {
      this.referralRequest.trackingCodeMessage = 'Required';
      result = false;
    } else if (!/^\d+$/.test(this.referralRequest.trackingCode)) {
      this.referralRequest.trackingCodeMessage = 'invalid_Pattern';
      result = false;
    } else if (this.referralRequest.trackingCode.length < 3) {
      this.referralRequest.trackingCodeMessage = 'invalid_Length';
      result = false;
    } else {
      this.referralRequest.trackingCodeMessage = undefined;
    }

    return result;
  }

  public getPrescription() {
    try {
      this.closeAllCollapse();
      if (!this.validatePrescription()) {
        if (
          !this.isElectronic &&
          this.referralRequest.patientNationalCodeMessage == null
        ) {
          this.loginCitizen();
        }
        return;
      }
      this.loading = true;
      this.clearPage();
      this.checkCodes = [];

      this.salamtService
        .GetPrescription(
          this.referralRequest.patientNationalCode!,
          this.referralRequest.trackingCode!
        )
        .then((result) => {
          this.referral = {
            ...result,
            prescription: {
              ...result.prescriptions[0],
            },
          };

          const drugs = _.cloneDeep(this.referral.prescription.drugs);

          const drugsWithIndex = drugs.map((drug, index) => {
            const value = drug.serviceNationalNumber
              ? drug.serviceNationalNumber.trim()
              : '';
            const isNegative = value.startsWith('-');
            const numericPart = isNegative ? value.substring(1) : value;
            const isNumeric = /^\d+$/.test(numericPart);
            const writeWithBrand =
              numericPart.length > 6 && !isNegative && isNumeric;

            return {
              ...drug,
              writeWithBrand,
              index,
            };
          });

          this.referral.prescription.originalDrugs = drugsWithIndex;
          this.referral.prescription.drugs = drugsWithIndex;

          this.loading = false;
        })
        .catch((error) => {
          this.apiService.AddErrorLog(error);
        })
        .finally(() => {
          this.loading = false;
        });
    } catch (error) {
      this.logger.addError(error, false);
      this.loading = false;
      return;
    }
  }

  public getPrescriptionDetail() {
    if (this.referral == null) {
      this.logger.addError('referral is null ', false);
      return;
    }

    for (let j = 0; j < this.referral.prescription.drugs.length; j++) {
      const drug = this.referral.prescription.drugs[j];
      this.taminService
        .GetDrugDetailsVersionOne(drug)
        .then((result) => {
          if (this.referral == null) {
            return;
          }

          let foundedDrug = this.referral.prescription.drugs.find(
            (current) => current.id == drug.id
          );

          if (foundedDrug == null) {
            return;
          }

          foundedDrug.stock = result;
          foundedDrug.organizationSharePrice =
            (result.governmentSharePrice ?? 0) +
            (result.insuranceSharePrice ?? 0);
          foundedDrug.stock.loading = false;

          let foundedOriginalDrug =
            this.referral.prescription.originalDrugs.find(
              (current) => current.id == drug.id
            );

          if (foundedOriginalDrug == null) {
            return;
          }

          foundedOriginalDrug.stock = result;
          foundedOriginalDrug.stock.loading = false;
        })
        .catch((error) => {
          this.logger.addError(error, false);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  private selectValidation(drugItem: PrescriptionDrug): boolean {
    if (drugItem.stock == null) {
      var errorMessage = `${this.translate.instant('stock_undefined')} : ${
        drugItem.brandName
      } \n `;

      this.logger.addError(errorMessage, false);
      return false;
    }
    if (drugItem.stock.saleCount == null) {
      var errorMessage = `${this.translate.instant(
        'stock.saleCount_undefined'
      )} : ${drugItem.brandName} \n `;

      this.logger.addError(errorMessage, false);
      return false;
    }
    if (drugItem.requestCount == null) {
      var errorMessage = `${this.translate.instant(
        'Request_Count_undefined'
      )} : ${drugItem.brandName} \n `;

      this.logger.addError(errorMessage, false);
      return false;
    }
    if (drugItem.stock.inventoryCount == null) {
      var errorMessage = `${this.translate.instant(
        'inventory_Count_undefined'
      )} : ${drugItem.brandName} \n `;
      this.logger.addError(errorMessage, false);
      return false;
    }

    if (drugItem.requestCount > drugItem.stock.inventoryCount) {
      var errorMessage = `${this.translate.instant('Not_Enough_Inventory')} : ${
        drugItem.brandName
      } \n `;
      this.logger.addError(errorMessage, false);
      return false;
    }

    return true;
  }

  public selectItem(drugIndex: number, presIndex: number) {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      const drugItem = this.referral.prescription.drugs[drugIndex];

      if (!this.selectValidation(drugItem)) {
        return;
      }

      let selectItem = this.mapDetailToSelect(drugItem, drugItem.stock);

      if (this.referral.prescription.selectDrug == null) {
        this.referral.prescription.selectDrug = [];
      }
      this.referral.prescription.selectDrug.push(selectItem);

      this.removeFromBaseList(drugIndex);
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private mapDetailToSelect(
    drugItem: PrescriptionDrug,
    stockItem: PrescriptionDrugStock
  ): PrescriptionSelectDrug {
    try {
      let selectItem = _.cloneDeep(drugItem);

      let drugPackageCount: number =
        drugItem.stock.drugPackage == null ? 1 : drugItem.stock.drugPackage;

      drugPackageCount = drugPackageCount <= 0 ? 1 : drugPackageCount;

      selectItem.id = drugItem.id;
      selectItem.brandName = stockItem.brandName;
      selectItem.expireDate = stockItem.expireDate;
      selectItem.count = stockItem.saleCount == null ? 1 : stockItem.saleCount;
      selectItem.drugPackage = selectItem.count / drugPackageCount;

      // selectItem.price = drugItem.basePrice;
      // selectItem.organizationSharePrice = drugItem.prefExchangePart;
      // selectItem.insuranceSharePrice = drugItem.orgAmount;

      selectItem.organizationId = drugItem.prefExchangePart;
      selectItem.inventoryDetailId = drugItem.stock.inventoryDetailId;
      selectItem.stockId = drugItem.stock.stockId;
      selectItem.drugId = '00000000-0000-0000-0000-000000000000';
      selectItem.genericCode = drugItem.genericCode;
      selectItem.genericName = drugItem.genericName;
      selectItem.checkDeliverCode = drugItem.checkDeliverCode;

      return selectItem;
    } catch (error) {
      throw error;
    }
  }

  public selectAll(presIndex: number) {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      let newDetailList: PrescriptionDrug[] = [];
      this.referral.prescription.drugs.forEach((element) => {
        if (!this.selectValidation(element)) {
          newDetailList.push(element);
        } else if (element.messages.informationMessage.length > 0) {
          newDetailList.push(element);
        } else {
          if (this.referral!.prescription.selectDrug == null) {
            this.referral!.prescription.selectDrug = [];
          }
          this.referral!.prescription.selectDrug.push(
            this.mapDetailToSelect(element, element.stock)
          );
        }
      });

      this.referral.prescription.drugs = newDetailList;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public deSelectItem(item: any) {
    try {
      if (this.referral.prescription.selectDrug == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      this.removeFromSaleFactor(item);
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public deSelectAll() {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      const selectedLength = this.referral.prescription.selectDrug.length;

      for (let index = 0; index < selectedLength; index++) {
        this.deSelectItem(0);
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public openEdit(item: PrescriptionDrug) {
    try {
      if (this.editItem != undefined) {
        this.editItem = undefined;
      }
      this.editItem = _.cloneDeep(item);
      this.editItem!.stock.saleCount = item.requestCount;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public parentSearchAction(event: PCTableOutputModel) {
    try {
      switch (event.action) {
        case 'Sort':
          this.listLoading = true;
          if (this.searchRequestModel.orderBy == '') {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.orderBy != event.data) {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.direction == '') {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.direction == 'asd') {
            this.searchRequestModel.direction = 'desc';
          }

          this.searchRequestModel.orderBy = event.data;

          this.searchDrug();
          break;
        case 'Paging':
          this.listLoading = true;

          this.searchRequestModel.pageNumber = event.data;
          this.searchDrug();
          break;
        case 'PageSize':
          this.listLoading = true;
          this.searchRequestModel.pageSize = event.data;
          this.searchDrug();
          break;
        case 'SelectItem':
          this.selectDrug(event);
          break;
        case 'Successed':
          this.modalSuccessConfirm = false;
          break;
        default:
          break;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public selectDrug(event: PCTableOutputModel) {
    try {
      const selectItem = event.data;
      if (this.editItem == null) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }
      if (selectItem.count == 0) {
        this.logger.addError(
          'موجودی این کالا صفر است و امکان انتخاب برای فروش را ندارد',
          false
        );
        return;
      }
      if (this.editItem.stock.saleCount == null) {
        this.editItem.stock.saleCount = 1;
      }
      if (this.editItem.organizationSharePrice == null) {
        this.editItem.organizationSharePrice = 0;
      }

      this.editItem.brandName = selectItem.brandName;
      this.editItem.genericCode = selectItem.genericCode;
      this.editItem.genericCodeString = selectItem.genericCode;
      this.editItem.serviceNationalNumber = selectItem.nationalNumber;
      this.editItem.requestCount = 1;

      this.activeSearch = false;
      this.bulkModalIsOpen = false;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public validateSaveEditChange() {
    let isValid = true;
    if (this.editItem == null) {
      this.logger.addError('Unknown', false);
      return;
    }

    if (
      this.editItem.stock.brandName == null ||
      this.editItem.stock.brandName == '' ||
      this.editItem.stock.brandName.length <= 2
    ) {
      this.editItemValidation.stock.brandName = 'Required';
      isValid = false;
    } else {
      this.editItemValidation.stock.brandName = undefined;
    }

    if (
      this.editItem.stock.saleCount == null ||
      this.editItem.stock.saleCount.toString() == '' ||
      this.editItem.stock.saleCount <= 0
    ) {
      this.editItemValidation.stock.saleCount = 'Required';
      isValid = false;
    } else {
      this.editItemValidation.stock.saleCount = undefined;
    }

    if (
      this.editItem.serviceNationalNumber == null ||
      this.editItem.serviceNationalNumber.toString() == '' ||
      +this.editItem.serviceNationalNumber < 0 ||
      this.editItem.serviceNationalNumber.length <= 5
    ) {
      this.editItemValidation.serviceNationalNumber = 'Required';
      isValid = false;
    } else {
      this.editItemValidation.serviceNationalNumber = undefined;
    }

    if (
      this.editItem.requestCount == null ||
      this.editItem.requestCount.toString() == '' ||
      this.editItem.requestCount <= 0
    ) {
      this.editItemValidation.requestCount = 'Required';
      isValid = false;
    } else {
      this.editItemValidation.requestCount = undefined;
    }

    if (
      this.editItem.consumption == null ||
      this.editItem.consumption == '' ||
      this.editItem.consumption.length <= 3
    ) {
      this.editItemValidation.consumption = 'Required';
      isValid = false;
    } else {
      this.editItemValidation.consumption = undefined;
    }

    if (
      this.editItem.numberOfPeriod == null ||
      this.editItem.numberOfPeriod.toString() == '' ||
      this.editItem.numberOfPeriod <= 0
    ) {
      this.editItemValidation.numberOfPeriod = 'Required';
      isValid = false;
    } else {
      this.editItemValidation.numberOfPeriod = undefined;
    }

    return isValid;
  }

  public saveEditChange() {
    try {
      if (!this.validateSaveEditChange()) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.logger.clearChangePage();
      this.editableLoading = true;
      let backendJson = {
        NationalCode: this.referralRequest.patientNationalCode,
        TrackingCode: this.referralRequest.trackingCode,
        CitizenSessionId: this.referral?.citizenToken,
        samadCode: this.referral?.samadCode ?? '',
        isElectronic: this.isElectronic,
        drug: this.editItem,
        otherCheckCodeList: this.convertCheckCodeToList(),
      };

      const url = `SaleElectronicPrescription/CheckDeliverSubscription`;

      this.showEditable = false;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          const checkDeliver = new checkOtherServices(
            result.data.checkDeliverCode
          );
          this.checkCodes.push(
            new checkCodeViewModel(
              0,
              this.editItem?.id ?? '',
              result.data.checkDeliverCode
            )
          );

          this.mapSelectItem(result);
          this.modalService.dismissAll();
          return;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {
          this.editableLoading = false;
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public saveAddDrug() {
    try {
      this.loading = true;
      this.editableLoading = true;
      if (this.editItem == null) {
        this.logger.addError('Unknown', false);
        return;
      }
      if (this.isElectronic) {
        this.editItem.isOutOfPrescription = true;
      }
      this.editItem.typeId = 1;
      this.editItem.checkCode = '';
      let backendJson = {
        nationalCode: this.referralRequest.patientNationalCode,
        trackingCode: this.referralRequest.trackingCode ?? '',
        samadCode: this.referral?.samadCode ?? '',
        isElectronic: this.isElectronic,
        citizenSessionId: this.referral?.citizenToken,
        drug: this.editItem,
        otherCheckCodeList: this.convertCheckCodeToList(),
      };

      const url = `SaleElectronicPrescription/CheckDeliverSubscription`;

      this.showEditable = false;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          const checkDeliver = new checkOtherServices(
            result.data.checkDeliverCode
          );
          this.checkCodes.push(
            new checkCodeViewModel(
              0,
              result.data.id ?? '',
              result.data.checkDeliverCode
            )
          );

          this.mapAddItem(result);
          return;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {
          this.editableLoading = false;
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private convertCheckCodeToList() {
    return this.checkCodes.map(
      (current) => new checkOtherServices(current.checkCode)
    );
  }

  private mapSelectItem(item: any) {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }
      if (this.editItem == null) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }

      var foundedItem = this.referral.prescription.drugs.find(
        (current) => current.id == this.editItem!.id
      );

      if (foundedItem == null) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }

      foundedItem.stock = _.cloneDeep(this.editItem.stock);

      // let selectItem = this.mapDetailToSelect(foundedItem, foundedItem.stock);

      if (this.referral.prescription.selectDrug == null) {
        this.referral.prescription.selectDrug = [];
      }

      // selectItem.paidPrice = item.data.paidPrice;
      // selectItem.checkDeliverCode = item.data.checkDeliverCode;
      // selectItem.brandName = item.data.brandName;
      // selectItem.insuranceSharePrice = item.data.orgAmount;
      // selectItem.organizationSharePrice = item.data.organizationSharePrice;

      // selectItem.price =
      //   (selectItem.paidPrice ?? 0) +
      //   (selectItem.insuranceSharePrice ?? 0) +
      //   (selectItem.organizationSharePrice ?? 0);

      if (item.data.messages.warningMessage.length != 0) {
        this.logger.addListWarning(item.data.messages.warningMessage);
      }
      if (item.data.messages.errorMessage.length != 0) {
        this.logger.addListError(item.data.messages.errorMessage);
      }
      if (item.data.messages.informationMessage.length != 0) {
        this.logger.addListInfo(item.data.messages.informationMessage);
      }
      const allMessages = [
        ...item.data.messages.warningMessage,
        ...item.data.messages.errorMessage,
        ...item.data.messages.informationMessage,
      ];
      item.data['Esalat'] = allMessages.some((msg) => msg.includes('اصالت'));
      this.referral.prescription.selectDrug.push(item.data);
      this.referral.prescription.drugs =
        this.referral.prescription.drugs.filter(
          (current) => current.id != item.data.id
        );

      this.editItem = undefined;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private mapAddItem(item: any) {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }
      if (this.editItem == null) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }

      // var foundedItem = prescription.drugs.find(
      //   (current) => current.id == this.editItem!.id
      // );

      // if (foundedItem == null) {
      //   this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
      //   return;
      // }

      // foundedItem.stock = _.cloneDeep(this.editItem.stock);

      if (this.referral.prescription.selectDrug == null) {
        this.referral.prescription.selectDrug = [];
      }

      if (item.data.messages.warningMessage.length != 0) {
        this.logger.addListWarning(item.data.messages.warningMessage);
      }
      if (item.data.messages.errorMessage.length != 0) {
        this.logger.addListError(item.data.messages.errorMessage);
      }
      if (item.data.messages.informationMessage.length != 0) {
        this.logger.addListInfo(item.data.messages.informationMessage);
      }
      const allMessages = [
        ...item.data.messages.warningMessage,
        ...item.data.messages.errorMessage,
        ...item.data.messages.informationMessage,
      ];
      item.data['Esalat'] = allMessages.some((msg) => msg.includes('اصالت'));
      this.referral.prescription.selectDrug.push(item.data);

      this.editItem = undefined;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private mapBulkSelectItem(item: any, bulkSelectItem) {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }
      if (this.bulkItemList == null || this.bulkItemList.length == 0) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }

      var foundedItem = this.referral.prescription.drugs.find(
        (current) => current.id == item.id
      );

      if (foundedItem == null) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }

      if (this.referral.prescription.selectDrug == null) {
        this.referral.prescription.selectDrug = [];
      }

      item.organizationSharePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
      item.basePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.basePrice || 0),
        0
      );
      item.prefExchangePart = bulkSelectItem.reduce(
        (sum, current) => sum + (current.prefExchangePart || 0),
        0
      );
      item.prefExchangePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.prefExchangePrice || 0),
        0
      );
      item.totalPrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.totalPrice || 0),
        0
      );
      item.paidPrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.paidPrice || 0),
        0
      );
      item.orgAmount = bulkSelectItem.reduce(
        (sum, current) => sum + (current.orgAmount || 0),
        0
      );
      item.phaDrugPrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.phaDrugPrice || 0),
        0
      );
      item.maxDrugPrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.maxDrugPrice || 0),
        0
      );
      item.organizationSharePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
      item.organizationSharePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
      item.organizationSharePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
      item.organizationSharePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
      item.organizationSharePrice = bulkSelectItem.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );

      item.bulkDrugInfos = bulkSelectItem;

      this.referral.prescription.selectDrug.push(item);

      this.referral.prescription.drugs =
        this.referral.prescription.drugs.filter(
          (current) => current.id != item.id
        );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public searchDrug() {
    try {
      if (this.editItem?.brandName == null) {
        return;
      }
      const backendJson = {
        SearchClause: this.editItem?.brandName,
        PatientNationalCode: this.referralRequest.patientNationalCode,
        CitizenSessionId: this.referral?.citizenToken,
      };

      if (this.bulkModalIsOpen == false) {
        this.bulkModalIsOpen = true;
      }
      const url = `SaleElectronicPrescription/SearchQuickDrugByIRC`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.searchSalamatData = new PCTableInputModel(
            result.data?.info.map((current) => ({
              brandName: current.fullName,
              shortName: current.shortName,
              nationalNumber: current.nationalNumber,
              genericCode: current.genericCode,
              saleState: 'Success',
            })),
            [],
            true,
            1,
            this.searchRequestModel.orderBy,
            this.searchRequestModel.direction
          );
          setTimeout(() => {
            if (this.searchBoxComponent) {
              this.searchBoxComponent.InitPage();
            } else {
              console.error('PCTableComponent not found');
            }
          }, 2);
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public closeEditChange() {
    try {
      this.showEditable = false;
      this.editItem = undefined;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public closeAdd() {
    try {
      this.showAddBox = false;
      this.activeSearch = false;
      this.editItem = undefined;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public addDrug() {
    this.activeSearch = false;
  }

  public openModal(content: any) {
    try {
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' })
        .result.then(
          (result) => {
            if (result == 'Save click') {
            }
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          },
          (reason) => {
            setTimeout(() => {
              this.modalIsOpen = false;
            }, 1 * 1000);
          }
        );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private removeFromBaseList(drugIndex: number) {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      if (this.referral.prescription == null) {
        this.logger.addError(
          'خطایی رخ داده صفحه را به روز رسانی نمایید',
          false
        );
        return;
      }

      let drug = this.referral.prescription.drugs[drugIndex];

      if (drug == null) {
        this.logger.addError(
          'خطایی رخ داده صفحه را به روز رسانی نمایید',
          false
        );
        return;
      }

      if (drug.requestCount == null) {
        drug.requestCount = 1;
      }

      if (this.editItem!.requestCount == null) {
        this.editItem!.requestCount = 1;
      }

      if (this.editItem!.requestCount == drug.requestCount) {
        this.referral.prescription.drugs.splice(drugIndex, 1);
      } else {
        drug.requestCount = drug.requestCount - this.editItem!.requestCount;
        drug.stock = new PrescriptionDrugStock();
        drug.isSelected = true;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private removeFromSaleFactor(item: any) {
    try {
      if (this.referral.prescription.selectDrug == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      this.checkCodes = this.checkCodes.filter((item) => item.id !== item.id);

      this.referral.prescription.selectDrug =
        this.referral.prescription.selectDrug.filter(
          (current) => current.id != item.id
        );

      const selectedIds = new Set(
        this.referral.prescription.selectDrug.map((drug) => drug.id)
      );
      this.referral.prescription.drugs =
        this.referral.prescription.originalDrugs.filter(
          (drug) => !selectedIds.has(drug.id)
        );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public printParentAction(event: PCTableOutputModel) {
    try {
      switch (event.action) {
        case 'ClosePrintModal':
          this.referral = new Referral();
          this.recept = undefined;
          this.referralRequest = new ReferralRequest();
          this.receptModalIsOpen = false;
          break;
        default:
          break;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public bulkRecord(
    orgItem: PrescriptionDrug,
    item: PrescriptionDrug,
    subIndex: number,
    newItem: any = null
  ) {
    if (newItem == null) {
      this.bulkItemList = [];
    } else {
      this.bulkItemList.push(newItem.data);
    }
    this.showEditable = false;
    const element = item.bulkDrugInfos[subIndex];
    if (element == null) {
      this.mapBulkSelectItem(orgItem, this.bulkItemList);
      this.loading = false;
      return;
    }
    this.getBulkIRC(element, orgItem, item, subIndex);
  }

  private getBulkIRC(
    element,
    orgItem: PrescriptionDrug,
    item: PrescriptionDrug,
    subIndex: number
  ) {
    try {
      const backendJson = {
        GenCode: element.genericCode,
        NationalCode: this.referralRequest.patientNationalCode,
        CitizenSessionId: this.referral?.citizenToken,
      };

      const url = `SaleElectronicPrescription/GetIRCListDrug`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.info == null || result.info.length == 0) {
            this.logger.addError(
              `شناسه یکتا IRC برای دارو ترکیبی یافت نشد.  ${element.name}`,
              false
            );
            this.loading = false;
            return;
          }
          let ircList = result.info;
          ircList = ircList.map((item) => {
            return {
              ...item,
              fullName: item.fullName.replace('-BULK', ''),
            };
          });
          const foundedItem = ircList.find(
            (current) => current.fullName == element.name
          );
          if (foundedItem == null) {
            this.logger.addError(
              `شناسه یکتا IRC برای دارو ترکیبی یافت نشد.  ${element.name}`,
              false
            );
            this.loading = false;
            return;
          }

          this.getBulkCkeckCode(
            element,
            orgItem,
            item,
            subIndex,
            foundedItem.nationalNumber
          );
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private getBulkCkeckCode(
    element,
    orgItem: PrescriptionDrug,
    item: PrescriptionDrug,
    subIndex,
    nationalNumber
  ) {
    let drugElement = item;
    drugElement.brandName = element.name;
    drugElement.requestCount = element.count;
    drugElement.bulkId = element.bulkId;
    drugElement.genericCodeString = element.genericCode;
    drugElement.consumption = element.consumption;
    drugElement.consumptionInstruction = element.consumptionInstruction;
    drugElement.description = element.description ?? '';
    drugElement.type = element.type;
    drugElement.typeId = element.typeId;
    drugElement.isOutOfPrescription = false;
    drugElement.shape = element.shape;
    drugElement.serviceNationalNumber = nationalNumber;
    drugElement.numberOfPeriod = element.numberOfPeriod;
    drugElement.checkCode = element.checkCode;

    try {
      let backendJson = {
        NationalCode: this.referralRequest.patientNationalCode,
        TrackingCode: this.referralRequest.trackingCode,
        CitizenSessionId: this.referral?.citizenToken,
        drug: drugElement,
        samadCode: this.referral?.samadCode ?? '',
        isElectronic: this.isElectronic,
        otherCheckCodeList: this.convertCheckCodeToList(),
      };

      const url = `SaleElectronicPrescription/CheckDeliverSubscription`;

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          const checkDeliver = new checkCodeViewModel(
            0,
            item.id ?? '',
            result.data.checkDeliverCode
          );
          this.checkCodes.push(checkDeliver);
          element.basePrice = result.data.basePrice;
          element.prefExchangePart = result.data.prefExchangePart;
          element.prefExchangePrice = result.data.prefExchangePrice;
          element.totalPrice = result.data.totalPrice;
          element.paidPrice = result.data.paidPrice;
          element.orgAmount = result.data.orgAmount;
          element.organizationSharePrice = result.data.organizationSharePrice;

          this.bulkRecord(orgItem, item, subIndex + 1, result);
          return;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public changePrescriptionStatus() {
    if (this.isElectronic) {
      this.isElectronic = false;
      this.referralRequest.trackingCode = undefined;
    } else {
      this.isElectronic = true;
      this.referralRequest.trackingCode = undefined;
    }
  }
  public rowClick(item: PrescriptionDrug) {
    try {
      this.openModal(this.itemEditModal);
      this.showAddBox = false;
      this.loading = true;
      this.editableListItem = [];
      if (item.bulkDrugInfos != null && item.bulkDrugInfos.length > 0) {
        const bulkClickItem = _.cloneDeep(item);
        this.bulkRecord(item, bulkClickItem, 0);
        return;
      }
      this.editItem = item;
      this.showEditable = true;

      this.editItem.stock.saleCount = this.editItem.requestCount;

      if (item.writeWithBrand) {
        if (item.stock.drugId != undefined) {
          this.editableLoading = false;
          this.loading = false;
          this.editableListItem = [];
          return;
        } else {
          let advertizementSearch: string | undefined = undefined;
          if (item.brandName != null) {
            advertizementSearch = item.brandName.split(' ')[0];
          }

          if (advertizementSearch != null) {
            this.editItem.stock.brandName = advertizementSearch;
            setTimeout(() => {
              this.searchWithName();
            }, 20);
            return;
          }
          this.editableLoading = false;
          this.loading = false;
          this.editableListItem = [];
          return;
        }
      }
      this.showEditable = true;

      const backendJson = {
        GenCode: item.genericCodeString,
        NationalCode: this.referralRequest.patientNationalCode,
        CitizenSessionId: this.referral?.citizenToken,
      };

      const url = `SaleElectronicPrescription/GetIRCListDrug`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          setTimeout(() => {
            this.editableListItem = result.info.map((current) => ({
              persianName:
                current.fullName + '   -------   ' + current.basePrice + 'ریال',
              id: current.nationalNumber,
            }));
          }, 20);
          return;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {
          this.editableLoading = false;
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      this.loading = false;
      return;
    }
  }

  public selectToUploadBarcode(drugIndex: number) {
    try {
      if (this.referral == null) {
        this.logger.addError('Unknown', false);
        return;
      }
      let thisItem = this.referral.prescription.selectDrug[drugIndex];
      if (thisItem == null) {
        this.logger.addError('Unknown', false);
        return;
      }
      this.barcodeDrugIndex = drugIndex;
      this.uploadBarcodeItem = thisItem;
      this.uidViewModel = new uidViewModel(
        this.referral.token ?? '',
        this.referral.citizenToken ?? '',
        this.referralRequest.patientNationalCode ?? '',
        thisItem.checkDeliverCode,
        '',
        1,
        drugIndex
      );
      if (thisItem.barcode == null) {
        thisItem.barcode = [];
      }
      thisItem.barcode = thisItem.barcode.filter((current) => !current.active);
      let newItem = new UIdModel('');
      thisItem.barcode.push(newItem);
      setTimeout(() => {
        this.openModal(this.ScanBarcodeModal);
      }, 100);
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public parentBarcodeAction(event: PCTableOutputModel) {
    try {
      switch (event.action) {
        case 'SaveUid':
          this.sendEsalat(event.data);
          break;

        case 'closeUid':
          this.uploadBarcodeItem = undefined;
          this.barcodeDrugIndex = undefined;
          this.modalService.dismissAll();
          break;

        case 'AddToPrescription':
          if (this.referral == null || this.referral.prescription == null) {
            this.logger.addError('Unknown', false);
            return;
          }
          let foundedItem = this.referral.prescription.selectDrug.find(
            (current) => current.id == event.data.id
          );
          if (foundedItem == null) {
            this.logger.addError('Unknown', false);
            return;
          }
          foundedItem.barcode = event.data.uIds;

          this.modalSuccessConfirm = true;
          this.modalService.dismissAll();
          break;
        default:
          break;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private sendEsalat(item: UIdModel[]) {
    try {
      this.loading = true;

      if (item.length == 0) {
        this.logger.addError('بارکد نا معتبر ', false);
        this.loading = false;
        return;
      }
      const thisItem = item[0];
      if (
        thisItem.uId == null ||
        thisItem.uId == '' ||
        thisItem.uId.length != 20
      ) {
        this.logger.addError('بارکد نا معتبر ', false);
        this.loading = false;
        return;
      }

      let url = `SaleElectronicPrescription/InquiryUIdSubscription`;

      const backendJson = {
        CitizenSessionId: this.referral?.citizenToken,
        NationalCodeL: this.referralRequest.patientNationalCode,
        CheckCode: undefined,
        UId: undefined,
        Count: 1,
      };
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded) {
            this.loginState++;
          }
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addClientException(error, 'saveDrugCode');
    }
  }

  private validationBeforConfirm(
    prescription: Prescription
  ): string | undefined {
    let result: string = '';

    if (this.referral == null) {
      return 'Unknown_Error';
    }

    var foundedRequierdBarcode = prescription.selectDrug.filter(
      (current) => current.requiresBarcodeInquiry == '1'
    );

    foundedRequierdBarcode.forEach((element) => {
      if (element.barcode == undefined) {
        result += `${this.translate.instant('Barcode_Requierd')} : ${
          element.brandName
        } \n `;
      } else if (element.barcode.length == 0) {
        result += `${this.translate.instant('Barcode_Requierd')} : ${
          element.brandName
        } \n `;
      } else if (element.barcode.length < element.count) {
        result += `${this.translate.instant('Barcode_Not_Enoght')} : ${
          element.brandName
        } \n `;
      }
    });

    prescription.selectDrug.forEach((element) => {
      if (element.requestCount == undefined) {
        result += `${this.translate.instant('Request_Count_undefined')} : ${
          element.brandName
        } \n `;
      }
    });
    if (result == '') {
      return undefined;
    }
    return result;
  }

  public DeliveringPrescription() {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }
      const url = `SaleElectronicPrescription/DeliveringPrescription`;

      if (this.referral.prescription == null) {
        this.logger.addError('DontSelectDrugElecPresc', false);
        return;
      }

      if (this.referral.doctorId == null) {
        this.logger.addError('DontSelectDrugElecPresc', false);
        return;
      }

      const validationError = this.validationBeforConfirm(
        this.referral.prescription
      );
      if (validationError != undefined) {
        this.logger.addError(validationError, false);
        return;
      }

      this.loading = true;

      let drugList: any[] = [];
      let preInvoiceDrugList: any[] = [];
      this.referral.prescription.selectDrug.forEach((element) => {
        if (element.bulkId != 0) {
          element.bulkDrugInfos.forEach((bulk) => {
            bulk.barcode = bulk.barcode ?? [];
            const uIds = bulk.barcode.filter(
              (current) => current.active == false
            );

            const drug = {
              drugName: bulk.brandName,
              count: bulk.requestCount,
              drugId: bulk.drugId ?? this.guid.EmptyGuid(),
              description: bulk.description ?? '',
              discount: 0,
              doctorOrder: bulk.consumption,
              tTACTrackingCode: null,
              checkDeliverCode: bulk.checkDeliverCode ?? '',
              elementPrice: bulk.price ?? 0,
              sellPrice: bulk.basePrice ?? 0,
              paidPrice: bulk.paidPrice ?? 0,
              totalPrice: bulk.totalPrice ?? 0,
              shareCurrencyPrice: bulk.prefExchangePart ?? 0,
              orgAmount: bulk.orgAmount ?? 0,
              uIds: uIds,
            };
            preInvoiceDrugList.push(drug);
          });
        } else {
          element.barcode = element.barcode ?? [];
          const uIds = element.barcode.filter(
            (current) => current.active == false
          );

          const drug = {
            // organizationId:element.
            doctorOrder: element.consumption,

            totalPrice: element.totalPrice ?? 0,
            discount: 0,
            genericCode: element.genericCode,
            genericCodeString: element.genericCodeString,
            requestCount: element.requestCount,
            description: element.description,
            checkDeliverCode: element.checkDeliverCode ?? '',
            brandName: element.brandName,
            drugId: element.stock.drugId,
            inventoryDetailId: element.stock.inventoryDetailId,
            stockId: element.stock.stockId,
            paidPrice: element.paidPrice ?? 0,
            orgAmount: element.orgAmount ?? 0,
            organizationSharePrice: element.prefExchangePart ?? 0,
            expireDate: element.stock.expireDate,
            drugForm: element.drugForm,
            uIds: uIds,

            saleCount: element.stock.saleCount,
            //TODO:nadare
            tTACTrackingCode: null,
            elementPrice: element.price ?? 0,
            sellPrice: element.basePrice ?? 0,
            shareCurrencyPrice: element.prefExchangePart ?? 0,
            //TODO:nadare
          };
          drugList.push(drug);
        }
      });
      if (this.referral.prescriptionDate == null) {
        this.logger.addError('prescriptionDate is null', false);
        return;
      }
      var prescriptionDate = this.calenderService.ToGregorian(
        this.referral.prescriptionDate
      );
      const backendJson = {
        token: this.referral.token,
        citizenToken: this.referral.citizenToken ?? '',
        trackingCode: this.referralRequest.trackingCode ?? '',
        saleFactorType: this.referral.saleFactorType ?? 4,
        nationalCode: this.referralRequest.patientNationalCode,
        patientFullName: this.referral.patientName,
        PatientFirstName: this.referral.patientFirstName,
        PatientLastName: this.referral.patientLastName,
        PatientBirthDate: this.referral.patientBirthDate,
        PatientGender: this.referral.patientGender == 'زن' ? 0 : 1,
        prescriptionId: this.referral.prescription.prescriptionId ?? '',
        doctorName: this.referral.doctorName,
        doctorSpecialty: this.referral.doctorSpecialty,
        noMedicalSystem: this.referral.doctorId.toString(), //Salamat
        insurancePrice: 0,
        paidPrice: 0,
        doctorId: this.referral.doctorId.toString(),
        otpCode: '',
        barcodesList: '', //barcode list
        drugs: drugList,
        preInvoiceDrugList: preInvoiceDrugList,
        prescriptionDate: prescriptionDate,
        temporarySubmittingCode: this.temporarySubmittingCode ?? '',
        technicalRight: this.technicalRight,
        samadCode: this.referral?.samadCode ?? '',
        isElectronic: this.isElectronic,
      };

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.succeeded == false) {
            if (result.data != null) {
              let taminMessages = '';
              result.errorMessages.forEach((element) => {
                taminMessages += element + '\n';
              });

              this.confirmModal = new ModalConfirm(
                'Tamin-Confrim',
                taminMessages,
                'ConfirmButton',
                'Confirm',
                'NotConfirm'
              );
              this.temporarySubmittingCode = result.data;
              this.modalConfirm = true;
              return;
            }
            this.logger.addBackEndMessage(result);
            return;
          }
          if (this.referral == null) {
            this.logger.addError('Unknow', false);
            return;
          }
          this.modalSuccessConfirm = true;
          this.recept = result.data;
          if (!this.recept) {
            this.loading = false;
            return;
          }
          this.receptModalIsOpen = true;
          var foundedBulk = this.referral.prescription.selectDrug.filter(
            (current) => current.bulkId != 0
          );
          var foundedNoBulk = this.referral.prescription.selectDrug.filter(
            (current) => current.bulkId == 0
          );

          this.recept.drugList = [];

          this.recept.drugList = this.recept.drugList.concat(
            foundedNoBulk.map((current) => {
              const item = new ReceptDrugList(
                current.brandName,
                current.requestCount,
                current.basePrice,
                current.totalPrice,
                '',
                current.orgAmount,
                current.prefExchangePart
              );

              if (
                current.persianConsumption == '' ||
                current.persianConsumption == null
              ) {
                const foundedItem = this.salamatData.find(
                  (x) => x.id == current.consumption
                );
                if (foundedItem != null) {
                  current.persianConsumption = foundedItem.persianName;
                }
              }
              item.doctorOrder =
                current.persianConsumption + '   ' + current.numberOfPeriod;
              item.description = current.description ?? '';
              item.paidPrice = current.paidPrice;
              return item;
            })
          );

          this.recept.drugList = this.recept.drugList.concat(
            foundedBulk.map((current) => {
              let item = new ReceptDrugList(
                current.brandName,
                0,
                0,
                0,
                '',
                0,
                0
              );
              item.paidPrice = 0;
              item.description = item.description ?? '';
              current.bulkDrugInfos.forEach((element) => {
                item.drugBranName += `<br> ${element.brandName}`;
                item.sellPrice += element.basePrice;
                item.totalPrice += element.totalPrice;
                item.insurancePrice += element.orgAmount;
                item.shareCurrencyPrice += element.prefExchangePart;
                item.paidPrice += element.paidPrice;
                if (item.description == '') {
                  item.description += `${element.description ?? ''}`;
                } else {
                  item.description += `<br> ${element.description ?? ''}`;
                }
              });

              if (
                current.persianConsumption == '' ||
                current.persianConsumption == null
              ) {
                const foundedItem = this.salamatData.find(
                  (x) => x.id == 'Every two hours'
                );
                if (foundedItem != null) {
                  current.persianConsumption = foundedItem.persianName;
                }
              }
              current.numberOfPeriod =
                current.numberOfPeriod == null || current.numberOfPeriod == 0
                  ? 1
                  : current.numberOfPeriod;
              item.doctorOrder =
                current.persianConsumption + '   ' + current.numberOfPeriod;
              item.paidPrice = current.paidPrice;
              return item;
            })
          );

          this.recept.totalAmount =
            this.referral.prescription.selectDrug.reduce(
              (sum, current) => sum + (current.totalPrice || 0),
              0
            );

          this.recept.insuranceAmount =
            this.referral.prescription.selectDrug.reduce(
              (sum, current) => sum + (current.orgAmount || 0),
              0
            );
          this.recept.nonInsuredPrice =
            this.referral.prescription.selectDrug.reduce(
              (sum, current) => sum + (current.prefExchangePart || 0),
              0
            );

          this.recept.technicalRight = this.technicalRight
            ? 0
            : +this.technicalRight;
          this.recept.paidPrice = this.referral.prescription.selectDrug.reduce(
            (sum, current) => sum + (current.paidPrice || 0),
            0
          );
          this.recept.paidPrice += this.recept.technicalRight;

          this.recept.patientAmount =
            this.referral.prescription.selectDrug.reduce(
              (sum, current) => sum + (current.paidPrice || 0),
              0
            );
          this.recept.patientAmount = this.recept.patientAmount ?? 0;
          this.recept.patientAmount += this.recept.technicalRight;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
    }
  }

  private mergItems(selectDrug: any[]) {
    var foundedItems: any[] = [];
    selectDrug.forEach((element) => {
      if (element.bulkId != 0) {
        const newName = `داروی ترکیبی ${element.bulkId}`;
        let foundedParent = selectDrug.find(
          (current) => current.bulkId == element.bulkId
        );
        let newDrug = _.cloneDeep(element);
        selectDrug = selectDrug.filter(
          (current) => current.id != foundedParent.id
        );
        foundedParent = selectDrug.find(
          (current) => current.brandName == newName
        );
        if (foundedParent == null) {
          newDrug.bulkDrugInfos.push(newDrug);
          newDrug.brandName = newName;
          selectDrug.push(newDrug);
        } else if (foundedParent.brandName == newName) {
          foundedParent.bulkDrugInfos.push(newDrug);
        }
      }
    });
    return selectDrug;
  }

  public parentAction(event: PCTableOutputModel) {
    switch (event.action) {
      case 'Confirm':
        this.modalConfirm = false;
        this.DeliveringPrescription();
        break;
      case 'NotConfirm':
        this.modalConfirm = false;
        break;
      case 'succeedUploadData':
        this.modalConfirm = true;

        if (!this.referral) {
          return;
        }

        if (this.referral.prescription == null) {
          this.logger.addError('DontSelectDrugElecPresc', false);
          return;
        }

        // prescription.selectDrug[event.data.selectIndex].

        break;

      default:
        break;
    }
  }

  public getDetailPrint(itemID: string) {
    try {
      if (this.recept != null && this.recept.id == itemID) {
        this.receptModalIsOpen = true;
        return;
      }
      this.listLoading = true;
      let url = `SaleFactor/Print/${itemID}`;
      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }

      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog('SaleFactor', result, `Get All`);
          if (result.succeeded) {
            this.recept = result.data;
            this.receptModalIsOpen = true;
          } else {
            this.logger.addBackEndMessage(result);
          }
          this.listLoading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.listLoading = false;
        },
        () => {
          this.listLoading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.listLoading = false;
    }
  }

  public onDropDownChange(selectedItem: any) {
    if (this.editItem == null) {
      this.logger.addError('Unknown', false);
      return;
    }

    this.editItem.serviceNationalNumber = selectedItem.id;
    let advertizementSearch: string | undefined = undefined;
    if (selectedItem.friendlyName != null) {
      advertizementSearch = selectedItem.friendlyName.split(' ')[0];
    }

    if (advertizementSearch != null) {
      this.editItem.stock.brandName = advertizementSearch;
      setTimeout(() => {
        this.searchWithName();
      }, 20);
    }
    this.validateSaveEditChange();
  }

  public addNewDrug() {
    this.openModal(this.itemEditModal);
    if (this.showAddBox) {
      this.editItem = undefined;
      this.showAddBox = false;
      return;
    }

    this.activeSearch = false;
    this.showAddBox = true;
    this.editItem = new PrescriptionDrug();
  }

  public searchWithName(): void {
    try {
      if (this.editItem == null) {
        return;
      }
      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = `SaleFactor/AdvanceSearch?search=${this.editItem.stock.brandName}&pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.loading = true;

      this.searchData = new PCTableInputModel(
        [],
        [],
        true,
        1,
        this.searchRequestModel.orderBy,
        this.searchRequestModel.direction
      );
      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (result.data?.pageCount! < result.data?.pageNumber!) {
              this.searchRequestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.searchRequestModel.orderBy,
              this.searchRequestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public searchDrugByGeneric(): void {
    try {
      if (this.editItem?.stock.genericCode == null) {
        return;
      }

      if (this.modalIsOpen == false) {
        this.modalIsOpen = true;
      }

      let url = `SaleFactor/AdvanceSearchByGenericCode?pageNumber=${this.searchRequestModel.pageNumber}&pageSize=${this.searchRequestModel.pageSize}&paging=${this.searchRequestModel.paging}&orderBy=${this.searchRequestModel.orderBy}&direction=${this.searchRequestModel.direction}&search=${this.editItem.stock.genericCode}`;

      if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
        return;
      }
      this.loading = true;
      this.searchData = new PCTableInputModel(
        [],
        [],
        true,
        1,
        this.searchRequestModel.orderBy,
        this.searchRequestModel.direction
      );
      this.apiService.getAll(new ApiRequestModel(url)).subscribe(
        (result) => {
          this.logger.addResponseLog(url, result, `Get All`);
          if (result.succeeded) {
            let firstItemOnPage = 1;
            if (result.data?.firstItemOnPage) {
              firstItemOnPage = result.data?.firstItemOnPage;
            }

            if (result.data?.pageCount! < result.data?.pageNumber!) {
              this.searchRequestModel.pageNumber = 1;
            }

            this.searchData = new PCTableInputModel(
              result.data?.items,
              [],
              true,
              firstItemOnPage,
              this.searchRequestModel.orderBy,
              this.searchRequestModel.direction
            );

            this.searchPaging = this.responseService.customizePaging(result);
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    } catch (e) {
      this.logger.addException(e, true);
      this.loading = false;
    }
  }

  public getSearchStockEntity() {
    this.apiService
      .getEntity(
        new ApiRequestModel(
          'SaleFactor',
          null,
          undefined,
          'SaleFactor',
          `InventorySearch`
        )
      )
      .subscribe(
        (result) => {
          this.logger.addResponseLog('SaleFactor', result, `Get Entity`);
          if (result.succeeded) {
            this.searchStockFields = this.apiService.convertStringToBoolean(
              result.data.fields
            );

            this.searchStockFields.forEach((element) => {
              element.camelCaseName = this.apiService.camelCase(
                element.fieldName
              );
            });

            if (result.data.count == 0) {
              this.logger.addError('Count is Zero .....!!!', false);
            }
          } else {
            this.logger.addBackEndMessage(result);
          }
        },
        (error) => {
          this.apiService.AddErrorLog(error);
        },
        () => {}
      );
  }

  public parentSearchStockAction(event: PCTableOutputModel) {
    try {
      switch (event.action) {
        case 'Sort':
          this.listLoading = true;
          if (this.searchRequestModel.orderBy == '') {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.orderBy != event.data) {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.direction == '') {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.direction == 'asd') {
            this.searchRequestModel.direction = 'desc';
          }

          this.searchRequestModel.orderBy = event.data;

          this.searchWithName();
          break;
        case 'Paging':
          this.listLoading = true;

          this.searchRequestModel.pageNumber = event.data;
          this.searchWithName();
          break;
        case 'PageSize':
          this.listLoading = true;
          this.searchRequestModel.pageSize = event.data;
          this.searchWithName();
          break;
        case 'SelectItem':
          this.selectStockDrug(event);
          break;
        case 'Successed':
          this.modalSuccessConfirm = false;
          break;
        default:
          break;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private selectStockDrug(event: any) {
    if (this.editItem == null) {
      this.logger.addError('Unknown', false);
      return;
    }

    const selectedItem = event.data;
    if (selectedItem == null) {
      this.logger.addError('Unknown', false);
      return;
    }

    if (
      selectedItem.inventoryDetails == null ||
      selectedItem.inventoryDetails.length == 0
    ) {
      this.editItem.stock.inventoryDetailId = this.guid.NewGuid();
      this.editItem.stock.price = selectedItem.inventoryDetails[0].sellPrice;
    } else {
      this.editItem.stock.inventoryDetailId =
        selectedItem.inventoryDetails[0].id;
      this.editItem.stock.expireDate =
        selectedItem.inventoryDetails[0].expireDate;
      this.editItem.stock.stockName =
        selectedItem.inventoryDetails[0].stockName;
      this.editItem.stock.inventoryCount =
        selectedItem.inventoryDetails[0].count;
      this.editItem.stock.price = selectedItem.price;
    }
    this.editItem.stock.drugId = selectedItem.drugId;
    this.editItem.stock.brandName = selectedItem.brandName;
    this.editItem.stock.drugPackage = selectedItem.drugPackage;
    this.editItem.stock.genericCode = undefined;

    this.modalIsOpen = false;
  }

  public closeAllCollapse() {
    this.closeEditChange();
    this.closeAdd();
  }

  //TODO : GetEntity For Search Drug

  //Paper Prescription

  public loginCitizen() {
    try {
      if (this.referralRequest.patientNationalCode == null) {
        this.referralRequest.patientNationalCodeMessage = 'Required';
        return;
      } else if (!/^\d+$/.test(this.referralRequest.patientNationalCode)) {
        this.referralRequest.patientNationalCodeMessage = 'invalid_Pattern';
        return;
      } else if (this.referralRequest.patientNationalCode.length != 10) {
        this.referralRequest.patientNationalCodeMessage = 'invalid_Length';
        return;
      } else {
        this.referralRequest.patientNationalCodeMessage = undefined;
      }
      this.loading = true;
      const url = `SaleElectronicPrescription/GetSalamatCitizen?nationalCode=${this.referralRequest.patientNationalCode}`;
      this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
        (result) => {
          const patientData = result.data.info;
          if (!patientData) {
            this.logger.addError('Unknown', false);
            return;
          }
          this.referral = new Referral();
          this.referral.doctorName = '-';
          this.referral.doctorId = '-';
          this.referral.clinicDoc = '-';
          this.referral.doctorSpecialty = '-';
          this.referral.prescriptionDate = '-';
          this.referral.patientName = `${patientData.name} ${patientData.lastName}`;
          this.referral.patientFirstName = patientData.name;
          this.referral.patientLastName = patientData.lastName;
          this.referral.patientBirthDate = patientData.birthDate;
          this.referral.patientGender =
            patientData.gender == 'F' ? 'زن' : 'مرد';
          this.referral.citizenToken = patientData.citizenSessionId;
          this.referral.patientInsuranceType = patientData.isCovered
            ? 'بیمه سلامت'
            : 'عدم پوشش بیمه';
          this.referralPaperDoctorRequest.visitDate =
            this.calenderService.GetNowDate();
          this.referralPaperDoctorRequest.expertiseGrade = 'doctor';
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public changeMonth(val: string) {
    if (this.popoverDataPicker.isOpen()) {
      this.popoverDataPicker.close();
    }
    this.monthName = val;
  }

  public searchDoctor() {
    try {
      const test = this.referralPaperDoctorRequest;
      if (this.referralPaperDoctorRequest.medicalCouncilCode == null) {
        this.referralPaperDoctorRequest.medicalCouncilCodeMessage = 'Required';
        return;
      } else if (
        !/^\d+$/.test(this.referralPaperDoctorRequest.medicalCouncilCode)
      ) {
        this.referralPaperDoctorRequest.medicalCouncilCodeMessage =
          'invalid_Pattern';
        return;
      } else {
        this.referralPaperDoctorRequest.medicalCouncilCodeMessage = undefined;
      }
      let shamsiDate = this.calenderService.ToJalali(
        this.referralPaperDoctorRequest.visitDate
      );
      if (shamsiDate == null) {
        this.referralPaperDoctorRequest.visitDateMessage = 'Required';
        return;
      }
      if (this.referral == null) {
        this.logger.addError('Unknown', false);
        return;
      }
      this.doctorSearchResult = [];
      const backendJson = {
        nomedicalSystem: +this.referralPaperDoctorRequest.medicalCouncilCode,
        visitDate: +shamsiDate.replaceAll('-', ''),
        expertiseGrade: this.referralPaperDoctorRequest.expertiseGrade,
        citizenSessionId: this.referral.citizenToken,
        patientNationalCode: this.referralRequest.patientNationalCode,
      };
      this.loading = true;
      const url = `SaleElectronicPrescription/SearchPartner`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.doctorSearchResult = result.data.info;
          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public selectDoctor(item: any) {
    try {
      if (this.referral == null) {
        this.logger.addError('Unknown', false);
        return;
      }
      let shamsiDate = this.calenderService.ToJalali(
        this.referralPaperDoctorRequest.visitDate
      );
      if (shamsiDate == null) {
        this.logger.addError('Unknown', false);
        return;
      }
      if (item == null) {
        this.logger.addError('Unknown', false);
        return;
      }

      const backendJson = {
        citizenSessionId: this.referral.citizenToken,
        paperInfoWrapper: {
          nomedicalSystem: item.nomedicalSystem,
          visitDate: +shamsiDate.replaceAll('-', ''),
          expertiseGrade: this.referralPaperDoctorRequest.expertiseGrade,
          partnerContractingPartyId: item.partnerContractingPartyId,
        },
      };
      this.loading = true;
      const url = `SaleElectronicPrescription/GenerateSamadCodePaper`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (!result.succeeded) {
            this.apiService.AddErrorLog(result);
            return;
          }
          if (this.referral == null) {
            this.logger.addError('Unknown', false);
            return;
          }
          this.referral.samadCode = result.data.info.samadCode;
          this.doctorSearchResult = [];
          this.referral.doctorId = item.nomedicalSystem;
          this.referral.doctorName = `${item.name} ${item.lastName}`;
          this.referral.doctorSpecialty = item.licenseType;
          this.referral.prescriptionDate = shamsiDate;
          this.referral.prescription = new Prescription();

          this.loading = false;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public openBulkModal() {
    this.openModal(this.bulkItem);
    if (this.referral == null) {
      this.logger.addError('Unknown', false);
      return;
    }
    const selectDrug = this.referral.prescription.selectDrug;
    if (selectDrug == null) {
      this.logger.addError('Unknown', false);
      return;
    }
    const foundedBulkList = selectDrug.filter((current) => current.bulkId > 0);
    this.bulkParentPaper = new PrescriptionDrug();
    this.newBulkParentPaper = new PrescriptionDrug();
    this.bulkParentPaper.bulkId = foundedBulkList.length + 1;
    this.bulkParentPaper.brandName = `دارو ترکیبی شماره ${this.bulkParentPaper.bulkId}`;
    this.bulkParentPaper.id = this.guid.NewGuid();
  }

  public deSelectBulkItem(item: any) {
    this.bulkParentPaper.bulkDrugInfos =
      this.bulkParentPaper.bulkDrugInfos.filter(
        (current) => current.id != item.id
      );
    this.checkCodes = this.checkCodes.filter(
      (current) => current.checkCode != item.checkDeliverCode
    );
  }

  public searchBulkDrug() {
    try {
      if (
        this.newBulkParentPaper.brandName == null ||
        this.newBulkParentPaper.brandName.length < 4
      ) {
        return;
      }
      const backendJson = {
        SearchClause: this.newBulkParentPaper.brandName,
        PatientNationalCode: this.referralRequest.patientNationalCode,
        CitizenSessionId: this.referral?.citizenToken,
        ProductType: this.searchWithIRC ? 'G' : 'I',
      };

      if (this.bulkModalIsOpen == false) {
        this.bulkModalIsOpen = true;
      }
      const url = `SaleElectronicPrescription/SearchQuickDrugByIRC`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          this.searchSalamatData = new PCTableInputModel(
            result.data?.info.map((current) => ({
              brandName: current.fullName,
              shortName: current.shortName,
              nationalNumber: current.nationalNumber,
              genericCode: current.genericCode,
              saleState: 'Success',
            })),
            [],
            true,
            1,
            this.searchRequestModel.orderBy,
            this.searchRequestModel.direction
          );
          setTimeout(() => {
            if (this.searchBoxComponent) {
              this.searchBoxComponent.InitPage();
            } else {
              console.error('PCTableComponent not found');
            }
          }, 2);
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public parentBulkSearchAction(event: PCTableOutputModel) {
    try {
      switch (event.action) {
        case 'Sort':
          this.listLoading = true;
          if (this.searchRequestModel.orderBy == '') {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.orderBy != event.data) {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.direction == '') {
            this.searchRequestModel.direction = 'asd';
          } else if (this.searchRequestModel.direction == 'asd') {
            this.searchRequestModel.direction = 'desc';
          }

          this.searchRequestModel.orderBy = event.data;

          this.searchDrug();
          break;
        case 'Paging':
          this.listLoading = true;

          this.searchRequestModel.pageNumber = event.data;
          this.searchDrug();
          break;
        case 'PageSize':
          this.listLoading = true;
          this.searchRequestModel.pageSize = event.data;
          this.searchDrug();
          break;
        case 'SelectItem':
          this.selectBulkDrug(event);
          break;
        case 'Successed':
          this.modalSuccessConfirm = false;
          break;
        default:
          break;
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public selectBulkDrug(event: PCTableOutputModel) {
    try {
      const selectItem = event.data;
      if (this.newBulkParentPaper == null) {
        this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
        return;
      }
      if (this.newBulkParentPaper.stock.saleCount == null) {
        this.newBulkParentPaper.stock.saleCount = 1;
      }
      if (this.newBulkParentPaper.organizationSharePrice == null) {
        this.newBulkParentPaper.organizationSharePrice = 0;
      }

      this.newBulkParentPaper.brandName = selectItem.brandName;
      this.newBulkParentPaper.genericCode = selectItem.genericCode;
      this.newBulkParentPaper.genericCodeString = selectItem.genericCode;
      this.newBulkParentPaper.serviceNationalNumber = selectItem.nationalNumber;
      this.newBulkParentPaper.requestCount = 1;

      this.activeBulkSearch = false;
      this.bulkModalIsOpen = false;
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public saveAddDrugBulk() {
    try {
      this.loading = true;
      this.editableLoading = true;
      if (
        this.newBulkParentPaper == null ||
        this.newBulkParentPaper.serviceNationalNumber == null
      ) {
        this.logger.addError('Unknown', false);
        return;
      }
      if (
        this.newBulkParentPaper.serviceNationalNumber.length < 6 ||
        +this.newBulkParentPaper.serviceNationalNumber < 0
      ) {
        this.getBulkIRCPaper();
      } else {
        this.confirmDeliverCheckCode();
      }
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  private confirmDeliverCheckCode() {
    try {
      this.loading = true;
      this.editableLoading = true;
      if (
        this.newBulkParentPaper == null ||
        this.newBulkParentPaper.serviceNationalNumber == null
      ) {
        this.logger.addError('Unknown', false);
        return;
      }

      this.newBulkParentPaper.typeId = 6;
      this.newBulkParentPaper.type = 'bulk';
      this.newBulkParentPaper.checkCode = '';
      this.newBulkParentPaper.bulkId = this.bulkParentPaper.bulkId;
      this.newBulkParentPaper.consumptionInstruction = '1';
      this.newBulkParentPaper.numberOfPeriod = 1;
      let backendJson = {
        nationalCode: this.referralRequest.patientNationalCode,
        trackingCode: this.referralRequest.trackingCode ?? '',
        samadCode: this.referral?.samadCode ?? '',
        isElectronic: this.isElectronic,
        citizenSessionId: this.referral?.citizenToken,
        drug: this.newBulkParentPaper,
        otherCheckCodeList: this.convertCheckCodeToList(),
      };

      const url = `SaleElectronicPrescription/CheckDeliverSubscription`;

      this.showEditable = false;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          const checkDeliver = new checkCodeViewModel(
            0,
            this.bulkParentPaper.id ?? '',
            result.data.checkDeliverCode
          );
          this.checkCodes.push(checkDeliver);
          this.newBulkParentPaper.checkDeliverCode =
            result.data.checkDeliverCode;
          this.newBulkParentPaper.basePrice = result.data.basePrice;
          this.newBulkParentPaper.prefExchangePart =
            result.data.prefExchangePart;
          this.newBulkParentPaper.prefExchangePrice =
            result.data.prefExchangePrice;
          this.newBulkParentPaper.totalPrice = result.data.totalPrice;
          this.newBulkParentPaper.paidPrice = result.data.paidPrice;
          this.newBulkParentPaper.orgAmount = result.data.orgAmount;
          this.newBulkParentPaper.organizationSharePrice =
            result.data.organizationSharePrice;
          if (result.data.messages.warningMessage.length != 0) {
            this.logger.addListWarning(result.data.messages.warningMessage);
          }
          if (result.data.messages.errorMessage.length != 0) {
            this.logger.addListError(result.data.messages.errorMessage);
          }
          if (result.data.messages.informationMessage.length != 0) {
            this.logger.addListInfo(result.data.messages.informationMessage);
          }

          const newData = _.cloneDeep(this.newBulkParentPaper);
          this.newBulkParentPaper.brandName = '';
          this.newBulkParentPaper = new PrescriptionDrug();
          this.bulkParentPaper.bulkDrugInfos.push(newData);
          if (this.bulkParentPaper.description == null) {
            this.bulkParentPaper.description = '';
          }
          this.bulkParentPaper.description += `<br> ${
            newData.description ?? ''
          }`;
          this.modalSuccessConfirm = true;
          return;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {
          this.editableLoading = false;
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public importBulkToPresc() {
    if (this.referral == null) {
      this.logger.addError('Unknown', false);
      return;
    }
    const selectDrug = this.referral.prescription.selectDrug;

    if (selectDrug == null) {
      this.logger.addError('Unknown', false);
      return;
    }
    this.bulkParentPaper.organizationId = '';
    this.bulkParentPaper.genericName = '';
    this.bulkParentPaper.genericCodeString = '';
    this.bulkParentPaper.erxCode = '';
    this.bulkParentPaper.shape = '';
    this.bulkParentPaper.consumption = '';
    this.bulkParentPaper.status = '';
    this.bulkParentPaper.consumptionSNOMEDCode = '';
    this.bulkParentPaper.requestCount = 0;
    this.bulkParentPaper.deliverCount = 0;
    this.bulkParentPaper.maxCoveredCount = 0;
    this.bulkParentPaper.shouldSendToEsalat = false;
    this.bulkParentPaper.isOutOfPrescription = false;
    this.bulkParentPaper.description = '';
    this.bulkParentPaper.typeId = 0;
    this.bulkParentPaper.type = '';
    this.bulkParentPaper.serviceNationalNumber = '';
    this.bulkParentPaper.numberOfPeriod = 0;
    this.bulkParentPaper.checkCode = '';
    this.bulkParentPaper.drugForm = '';

    this.bulkParentPaper.organizationSharePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
    this.bulkParentPaper.basePrice = this.bulkParentPaper.bulkDrugInfos.reduce(
      (sum, current) => sum + (current.basePrice || 0),
      0
    );
    this.bulkParentPaper.prefExchangePart =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.prefExchangePart || 0),
        0
      );
    this.bulkParentPaper.prefExchangePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.prefExchangePrice || 0),
        0
      );
    this.bulkParentPaper.totalPrice = this.bulkParentPaper.bulkDrugInfos.reduce(
      (sum, current) => sum + (current.totalPrice || 0),
      0
    );
    this.bulkParentPaper.paidPrice = this.bulkParentPaper.bulkDrugInfos.reduce(
      (sum, current) => sum + (current.paidPrice || 0),
      0
    );
    this.bulkParentPaper.orgAmount = this.bulkParentPaper.bulkDrugInfos.reduce(
      (sum, current) => sum + (current.orgAmount || 0),
      0
    );
    this.bulkParentPaper.phaDrugPrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.phaDrugPrice || 0),
        0
      );
    this.bulkParentPaper.maxDrugPrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.maxDrugPrice || 0),
        0
      );
    this.bulkParentPaper.organizationSharePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
    this.bulkParentPaper.organizationSharePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
    this.bulkParentPaper.organizationSharePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
    this.bulkParentPaper.organizationSharePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );
    this.bulkParentPaper.organizationSharePrice =
      this.bulkParentPaper.bulkDrugInfos.reduce(
        (sum, current) => sum + (current.organizationSharePrice || 0),
        0
      );

    const thisValue = _.cloneDeep(this.bulkParentPaper);
    this.referral.prescription.selectDrug.push(thisValue);
    this.bulkParentPaper.bulkDrugInfos = [];
    this.modalService.dismissAll();
    this.modalSuccessConfirm = true;
  }

  private getBulkIRCPaper() {
    try {
      const backendJson = {
        GenCode: this.newBulkParentPaper.genericCodeString,
        NationalCode: this.referralRequest.patientNationalCode,
        CitizenSessionId: this.referral?.citizenToken,
      };

      const url = `SaleElectronicPrescription/GetIRCListDrug`;
      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (result.info == null || result.info.length == 0) {
            this.logger.addError(
              `شناسه یکتا IRC برای دارو ترکیبی یافت نشد.  ${this.newBulkParentPaper.brandName}`,
              false
            );
            this.loading = false;
            return;
          }
          let ircList = result.info;
          ircList = ircList.map((item) => {
            return {
              ...item,
              fullName: item.fullName.replace('-BULK', ''),
            };
          });
          const foundedItem = ircList.find(
            (current) => current.fullName == this.newBulkParentPaper.brandName
          );
          if (foundedItem == null) {
            this.logger.addError(
              `شناسه یکتا IRC برای دارو ترکیبی یافت نشد.  ${this.newBulkParentPaper.brandName}`,
              false
            );
            this.loading = false;
            return;
          }

          this.newBulkParentPaper.serviceNationalNumber =
            foundedItem.nationalNumber;
          this.confirmDeliverCheckCode();
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {}
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }

  public GetTrackingCodePaper() {
    try {
      if (this.referral == null) {
        this.logger.addError('referral is null', false);
        return;
      }

      if (this.referral.prescription == null) {
        this.logger.addError('DontSelectDrugElecPresc', false);
        return;
      }

      if (this.referral.doctorId == null) {
        this.logger.addError('DontSelectDrugElecPresc', false);
        return;
      }

      const validationError = this.validationBeforConfirm(
        this.referral.prescription
      );
      if (validationError != undefined) {
        this.logger.addError(validationError, false);
        return;
      }

      this.loading = true;

      let drugList: any[] = [];

      if (this.referral.prescriptionDate == null) {
        this.logger.addError('prescriptionDate is null', false);
        return;
      }

      const backendJson = {
        cpartySessionId: this.referral.token ?? '',
        citizenSessionId: this.referral.citizenToken ?? '',
        samadCode: this.referral?.samadCode ?? '',
        nationalCode: this.referralRequest.patientNationalCode,
        subscriptions: this.convertCheckCodeToList(),
      };

      const url = `SaleElectronicPrescription/OrderPaperPrescription`;

      this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
        (result) => {
          if (this.referral == null) {
            this.logger.addError('Unknown', false);
            return;
          }
          let recept = new Recept();
          recept.drugStoreName = '';
          recept.drugStoreNumber = '';
          recept.drugStoreAddress = '';
          recept.factorNumber = '-';
          recept.factorDate = '-';
          let shamsiDate = this.calenderService.ToJalali(
            this.referralPaperDoctorRequest.visitDate
          );
          recept.prescriptionDate = shamsiDate;
          recept.patientNationalCode = this.referralRequest.patientNationalCode;
          recept.patientFullName = this.referral?.patientName;
          recept.doctorFullName = this.referral?.doctorName;
          recept.doctorId = this.referral?.doctorId;
          recept.barcode = '-';

          recept.totalAmount = this.referral.prescription.selectDrug.reduce(
            (sum, current) => sum + (current.totalPrice || 0),
            0
          );
          recept.patientAmount = this.referral.prescription.selectDrug.reduce(
            (sum, current) => sum + (current.paidPrice || 0),
            0
          );
          recept.insuranceAmount = this.referral.prescription.selectDrug.reduce(
            (sum, current) => sum + (current.orgAmount || 0),
            0
          );
          recept.nonInsuredPrice = this.referral.prescription.selectDrug.reduce(
            (sum, current) => sum + (current.prefExchangePart || 0),
            0
          );
          recept.technicalRight = this.technicalRight
            ? 0
            : +this.technicalRight;
          recept.paidPrice = this.referral.prescription.selectDrug.reduce(
            (sum, current) => sum + (current.paidPrice || 0),
            0
          );
          recept.paidPrice += recept.technicalRight;
          recept.insuranceName = 'بیمه سلامت';

          recept.trackingCode = result.info.trackingCode;
          recept.drugList = [];
          if (this.referral.prescription.selectDrug == null) {
            this.logger.addError('Unknown', false);
            return;
          }
          recept.drugList = this.referral.prescription.selectDrug.map(
            (current) => {
              if (current.bulkId > 0) {
                const drugItem = new ReceptDrugList(
                  current.brandName,
                  current.requestCount,
                  current.basePrice,
                  current.totalPrice,
                  '',
                  current.orgAmount,
                  current.prefExchangePart
                );

                current.bulkDrugInfos.forEach((element) => {
                  drugItem.drugBranName += `<br> ${element.brandName}`;
                });

                if (
                  current.persianConsumption == '' ||
                  current.persianConsumption == null
                ) {
                  const foundedItem = this.salamatData.find(
                    (x) => x.id == current.consumption
                  );
                  if (foundedItem != null) {
                    current.persianConsumption = foundedItem.persianName;
                  }
                }

                drugItem.doctorOrder = '';
                drugItem.description = current.description ?? '';
                drugItem.paidPrice = current.paidPrice;

                return drugItem;
              } else {
                const drugItem = new ReceptDrugList(
                  current.brandName,
                  current.requestCount,
                  current.basePrice,
                  current.totalPrice,
                  '',
                  current.orgAmount,
                  current.prefExchangePart
                );

                if (
                  current.persianConsumption == '' ||
                  current.persianConsumption == null
                ) {
                  const foundedItem = this.salamatData.find(
                    (x) => x.id == current.consumption
                  );
                  if (foundedItem != null) {
                    current.persianConsumption = foundedItem.persianName;
                  }
                }

                drugItem.doctorOrder =
                  (current.persianConsumption ?? '') +
                  '   ' +
                  (current.numberOfPeriod ?? '');
                drugItem.description = current.description ?? '';
                drugItem.paidPrice = current.paidPrice;

                return drugItem;
              }
            }
          );

          this.recept = _.cloneDeep(recept);
          this.receptModalIsOpen = true;

          return;
        },
        (error) => {
          this.apiService.AddErrorLog(error);
          this.editableLoading = false;
          this.loading = false;
        },
        () => {
          this.editableLoading = false;
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.addError(error, false);
      return;
    }
  }
}
